import { motion } from "framer-motion";

const BADGE_IDS = {
  mot_due: "mot-countdown-badge",
  council_due: "council-countdown-badge",
  tax_due: "road-tax-badge",
};

const COLORS = { safe: "#00E599", warning: "#FFB800", critical: "#FF3815", overdue: "#FF3815" };

const R = 30;
const C = 2 * Math.PI * R;

function Ring({ count }) {
  const { days_left: days, status } = count;
  const frac = Math.max(0, Math.min(days, 90) / 90);
  const color = COLORS[status] || COLORS.safe;
  return (
    <div className="relative w-[72px] h-[72px]">
      <svg viewBox="0 0 72 72" className="w-full h-full -rotate-90">
        <circle cx="36" cy="36" r={R} fill="none" stroke="#1E222B" strokeWidth="6" />
        <motion.circle
          cx="36" cy="36" r={R} fill="none" stroke={color} strokeWidth="6" strokeLinecap="round"
          strokeDasharray={C}
          initial={{ strokeDashoffset: C }}
          animate={{ strokeDashoffset: C * (1 - frac) }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-2xl font-black leading-none" style={{ color }}>
          {days}
        </span>
        <span className="text-[8px] font-mono uppercase tracking-[0.15em] text-low">
          {days < 0 ? "overdue" : days === 1 ? "day" : "days"}
        </span>
      </div>
    </div>
  );
}

export default function CountdownRing({ fieldId, vehicleId, label, count, onRenew }) {
  return (
    <div className="flex flex-col items-center gap-1.5" data-testid={`${BADGE_IDS[fieldId]}-${vehicleId}`}>
      {count ? (
        <Ring count={count} />
      ) : (
        <div className="w-[72px] h-[72px] rounded-full border-2 border-dashed border-line flex items-center justify-center font-mono text-xs text-low">
          N/A
        </div>
      )}
      <div className="text-center">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-mid">{label}</div>
        <div className="text-[10px] text-low font-mono">{count ? count.due : "no date"}</div>
      </div>
      <button
        type="button"
        onClick={onRenew}
        data-testid={`renew-${fieldId}-${vehicleId}`}
        className="font-mono text-[9px] uppercase tracking-[0.2em] text-low hover:text-ember transition-colors"
      >
        Renew
      </button>
    </div>
  );
}
